<template>
  <div class="topic-area">
    <h2 v-if="pgLoading" class="webkit-animation col-8 webkit-none-50"></h2>
    <VueSlickCarousel v-if="!pgLoading" v-bind="swiperOptions" ref="carousel">
      <div class="single-topic text-center mr-5 mb-30" v-for="(row, index) in items" :key="index + 1">
        <div class="topic-img" style="width: 100%;">
          <img :src="row.image" alt="" style="height: 700px; width: 100%">
          <div class="topic-content-box">
            <!-- <div class="topic-content">
              <h3>
                <a v-if="$i18n.locale == 'en'" href="#" v-html="row.en.title"></a>
                <a v-else href="#" v-html="row.ar.title"></a>
              </h3>
              <p v-if="$i18n.locale == 'en'" style="direction: ltr" v-html="row.en.body"></p>
              <p style="direction: ltr" v-html="row.ar.body"></p>
            </div> -->

            <img v-if="row.videoUrl && row.videoUrl" :src="row.videoUrl ? row.videoUrl : ''" :alt="row.en.title">
            <div class="video-icon" v-if="row.video_url">
              <a class="popup-video btn-icon" :href="row.video_url">
                <i class="icofont-ui-play"></i>
              </a>
            </div>

          </div>
        </div>
      </div>
    </VueSlickCarousel>
  </div>
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
// import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
export default {
  name: 'Sliders',
  components: {
    VueSlickCarousel
  },
  data() {
    return {
      //
      swiperOptions: {
        "dots": false,
        autoplay: true,
        autoplaySpeed: 1500,
        "arrows": false,
        "infinite": true,
        "speed": 500,
        "slidesToShow": 1,
        "slidesToScroll": 1,
        "initialSlide": 0,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false
            }
          },
        ]
      },
      items: null,
      pgLoading: true,
      refs: 'sliders'
    }
  },
  mounted() {
  },
  created() {
    //
    this.fetchData();
  },
  methods: {
    //
    fetchData() {
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + '/' + this.refs,
        method: 'GET',
        data: {},
        headers: {
          appId: process.env.VUE_APP_APPID
        }
      }
      this.axios(options)
        .then(res => {
          this.pgLoading = false;
          this.items = res.data.data.rows;
          setTimeout(function () {
            window.$('.popup-video').magnificPopup({
              type: 'iframe'
            });
          }, 300)
        });
    },

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.topic-img img,
.topic-area .single-topic::before {
  width: 100% !important;
}
</style>
